

// import React, { useEffect, useState } from 'react';
// import { Link, useHistory } from 'react-router-dom';
// import axios from 'axios';
// import Rightcontainer from '../Components/Rightcontainer';
// import socket from "../Components/socket";

// // Icons
// import { FaPlus, FaShieldAlt, FaChevronRight, FaWallet, FaHistory } from 'react-icons/fa';
// import { FaLandmark as FaBank } from "react-icons/fa"; 
// import { MdOutlineAccountBalanceWallet, MdOutlinePayments } from "react-icons/md";
// import { RiCoinLine, RiWallet3Fill } from "react-icons/ri";

// const Mywallet = () => {
//     const history = useHistory();
//     let access_token = localStorage.getItem('token');
//     const [settinData, setSettingData] = useState(undefined);
//     const [user, setUser] = useState(null);

//     const fetchUserData = () => {
//         access_token = localStorage.getItem('token');
//         if (!access_token) {
//             history.push('/login');
//             window.location.reload();
//             return;
//         }
//         const headers = { Authorization: `Bearer ${access_token}` };
//         axios
//             .get(`https://api.kakaking.in/me`, { headers })
//             .then(res => { setUser(res.data); })
//             .catch(e => {
//                 if (e.response && e.response.status === 401) {
//                     localStorage.removeItem('token');
//                     history.push('/login');
//                     window.location.reload();
//                 }
//             });
//     };

//     useEffect(() => { fetchUserData(); }, []);
//     useEffect(() => { socket.emit('websetting', ''); }, []);
//     useEffect(() => {
//         socket.on("websettingGet", (data) => {
//             localStorage.setItem("sitSetting", JSON.stringify(data));
//             setSettingData(data);
//         });
//         return () => socket.off("websettingGet");
//     }, [socket]);

//     const depositChips = user ? (user.Wallet_balance - user.withdrawAmount) : 0;
//     const winningChips = user?.withdrawAmount || 0;

//     return (
//         <>
//             <div className='leftContainer main-wallet-wrapper mt-5'>
//                 <div className='container wallet-content-area'>
                  
//                     {/* --- DEPOSIT SECTION --- */}
//                     <div className="classic-pro-card deposit-box">
//                         <div className="card-top">
//                             <div className="animated-icon-wrapper blue-vibe">
//                                 <RiWallet3Fill/>
//                             </div>
//                             <div className="card-title-area">
//                                 <label>Deposit Cash</label>
//                                 <h3>₹{depositChips.toFixed(2)}</h3>
//                             </div>
//                         </div>
//                         <div className="chip-indicator">
//                             <span className="dot blue-dot"></span> Used to Play Battles
//                         </div>
//                         <Link to={settinData?.isDeposit ? "/addcase" : "#"} className="action-link">
//                             <button className="pro-gradient-btn blue-grad" disabled={!settinData?.isDeposit}>
//                                 <FaPlus /> {settinData?.isDeposit ? "ADD CASH" : "LOCKED"}
//                             </button>
//                         </Link>
//                     </div>

//                     {/* --- WITHDRAW SECTION --- */}
//                     <div className="classic-pro-card withdraw-box">
//                         <div className="card-top">
//                             <div className="animated-icon-wrapper gold-vibe">
//                                 <RiCoinLine/>

//                             </div>
//                             <div className="card-title-area">
//                                 <label>Winning Cash</label>
//                                 <h3 className="gold-text">₹{winningChips.toFixed(2)}</h3>
//                             </div>
//                         </div>
//                         <div className="chip-indicator">
//                             <span className="dot green-dot"></span> Ready for Transfer
//                         </div>
//                         <Link to={settinData?.isWithdrawal ? "/Withdrawopt" : "#"} className="action-link">
//                             <button className="pro-gradient-btn gold-grad" disabled={!settinData?.isWithdrawal}>
//                                 <FaBank /> {settinData?.isWithdrawal ? "WITHDRAW NOW" : "LOCKED"}
//                             </button>
//                         </Link>
//                     </div>

//                     {/* --- SAFETY FOOTER --- */}
//                     <div className="secure-badge-footer">
//                         <div className="secure-content">
//                             <FaShieldAlt className="shield-anim" />
//                             <span>PCI-DSS COMPLIANT • SECURE GATEWAY</span>
//                         </div>
//                     </div>

//                 </div>
//             </div>

//             <div className='rightContainer'>
//                 <Rightcontainer />
//             </div>

//             <style>{`
//                 @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap');

//                 .main-wallet-wrapper {
//                     background: #F4F7FE;
//                     min-height: 100vh;
//                     font-family: 'Plus Jakarta Sans', sans-serif;
//                     padding-top: 20px;
//                 }

//                 .wallet-content-area {
//                     max-width: 440px;
//                     margin: 0 auto;
//                     padding: 20px;
//                     padding-top:40px    
//                 }

//                 /* Header Section */
//                 .premium-header-box {
//                     text-align: center;
//                     padding: 30px 20px;
//                     background: white;
//                     border-radius: 30px;
//                     box-shadow: 0 10px 30px rgba(145, 168, 201, 0.15);
//                     margin-bottom: 25px;
//                     position: relative;
//                     overflow: hidden;
//                     border: 1px solid rgba(255,255,255,0.8);
//                 }

//                 .header-icon-float {
//                     font-size: 40px;
//                     color: #0066ff;
//                     opacity: 0.1;
//                     position: absolute;
//                     right: -10px;
//                     top: -10px;
//                     transform: rotate(-15deg);
//                 }

//                 .total-main-balance {
//                     font-size: 38px;
//                     font-weight: 800;
//                     color: #1A202C;
//                     letter-spacing: -1px;
//                 }

//                 .text-muted-cap {
//                     text-transform: uppercase;
//                     font-size: 11px;
//                     font-weight: 700;
//                     color: #718096;
//                     letter-spacing: 1.5px;
//                 }

//                 /* Card Styles */
//                 .classic-pro-card {
//                     background: #FFFFFF;
//                     border-radius: 28px;
//                     padding: 24px;
//                     margin-bottom: 20px;
//                     box-shadow: 0 15px 35px rgba(0, 0, 0, 0.05);
//                     border: 1px solid #E2E8F0;
//                     transition: all 0.3s ease;
//                 }

//                 .card-top {
//                     display: flex;
//                     align-items: center;
//                     gap: 18px;
//                     margin-bottom: 15px;
//                 }

//                 .animated-icon-wrapper {
//                     width: 65px;
//                     height: 65px;
//                     border-radius: 20px;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     padding: 12px;
//                 }

//                 .blue-vibe { background: #EBF8FF; }
//                 .gold-vibe { background: #FFF9E6; }
//                 .animated-icon-wrapper img { width: 100%; height: auto; }

//                 .card-title-area label {
//                     font-size: 13px;
//                     font-weight: 700;
//                     color: #718096;
//                     margin: 0;
//                 }

//                 .card-title-area h3 {
//                     font-size: 26px;
//                     font-weight: 800;
//                     margin: 0;
//                     color: #2D3748;
//                 }

//                 .gold-text { color: #B7791F !important; }

//                 .chip-indicator {
//                     font-size: 12px;
//                     font-weight: 600;
//                     color: #A0AEC0;
//                     display: flex;
//                     align-items: center;
//                     gap: 6px;
//                     margin-bottom: 20px;
//                     padding-left: 5px;
//                 }

//                 .dot { width: 8px; height: 8px; border-radius: 50%; }
//                 .blue-dot { background: #4299E1; box-shadow: 0 0 8px #4299E1; }
//                 .green-dot { background: #48BB78; box-shadow: 0 0 8px #48BB78; }

//                 /* Button Styles */
//                 .pro-gradient-btn {
//                     width: 100%;
//                     padding: 16px;
//                     border-radius: 18px;
//                     border: none;
//                     font-weight: 800;
//                     font-size: 15px;
//                     letter-spacing: 1px;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     gap: 12px;
//                     cursor: pointer;
//                     transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
//                 }

//                 .blue-grad {
//                     background: linear-gradient(135deg, #0066FF 0%, #004ecc 100%);
//                     color: white;
//                     box-shadow: 0 10px 20px rgba(0, 102, 255, 0.3);
//                 }

//                 .gold-grad {
//                     background: linear-gradient(135deg, #2D3748 0%, #1A202C 100%);
//                     color: #F6AD55;
//                     box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
//                 }

//                 .pro-gradient-btn:hover:not(:disabled) {
//                     transform: translateY(-4px) scale(1.02);
//                 }

//                 .pro-gradient-btn:active { transform: scale(0.98); }

//                 .pro-gradient-btn:disabled {
//                     background: #E2E8F0;
//                     color: #A0AEC0;
//                     box-shadow: none;
//                     cursor: not-allowed;
//                 }

//                 /* Footer */
//                 .secure-badge-footer {
//                     margin-top: 30px;
//                     text-align: center;
//                 }

//                 .secure-content {
//                     display: inline-flex;
//                     align-items: center;
//                     gap: 8px;
//                     background: #EDF2F7;
//                     padding: 8px 20px;
//                     border-radius: 50px;
//                     font-size: 10px;
//                     font-weight: 800;
//                     color: #4A5568;
//                 }

//                 .shield-anim { color: #38A169; font-size: 14px; }

//                 @keyframes floatIn {
//                     from { opacity: 0; transform: translateY(20px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }

//                 .classic-pro-card { animation: floatIn 0.5s ease-out both; }
//                 .withdraw-box { animation-delay: 0.1s; }

//             `}</style>
//         </>
//     );
// };

// export default Mywallet;



import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import Rightcontainer from "../Components/Rightcontainer";
import socket from "../Components/socket";

import {
  FaPlus,
  FaShieldAlt,
  FaArrowRight,
  FaLandmark as FaBank,
} from "react-icons/fa";

import {
  RiCoinLine,
  RiWallet3Fill,
} from "react-icons/ri";

import {
  MdOutlineAccountBalanceWallet,
} from "react-icons/md";

// import "./Mywallet.css";


const Mywallet = () => {

  const history = useHistory();

  let access_token = localStorage.getItem("token");

  const [settinData, setSettingData] = useState(undefined);
  const [user, setUser] = useState(null);


  // =========================================
  // FETCH USER DATA
  // =========================================

  const fetchUserData = () => {

    access_token = localStorage.getItem("token");

    if (!access_token) {

      history.push("/login");

      window.location.reload();

      return;
    }

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    axios
      .get(`https://api.kakaking.in/me`, { headers })

      .then((res) => {

        setUser(res.data);

      })

      .catch((e) => {

        if (
          e.response &&
          e.response.status === 401
        ) {

          localStorage.removeItem("token");

          history.push("/login");

          window.location.reload();

        }

      });

  };


  // =========================================
  // USER
  // =========================================

  useEffect(() => {

    fetchUserData();

  }, []);


  // =========================================
  // WEB SETTINGS
  // =========================================

  useEffect(() => {

    socket.emit("websetting", "");

  }, []);


  useEffect(() => {

    socket.on("websettingGet", (data) => {

      localStorage.setItem(
        "sitSetting",
        JSON.stringify(data)
      );

      setSettingData(data);

    });

    return () =>
      socket.off("websettingGet");

  }, [socket]);


  // =========================================
  // BALANCE CALCULATION
  // =========================================

  const depositChips = user
    ? user.Wallet_balance - user.withdrawAmount
    : 0;

  const winningChips =
    user?.withdrawAmount || 0;


  // =========================================
  // UI
  // =========================================

  return (
    <>

      <div className="mywallet-page">


        {/* =====================================
            3D BACKGROUND
        ===================================== */}

        <div className="wallet-bg-orb wallet-orb-one"></div>

        <div className="wallet-bg-orb wallet-orb-two"></div>

        <div className="wallet-bg-orb wallet-orb-three"></div>

        <div className="wallet-bg-grid"></div>


        {/* =====================================
            MAIN CONTAINER
        ===================================== */}

        <div className="mywallet-container">


          {/* =====================================
              PAGE HEADER
          ===================================== */}

          <div className="wallet-page-header">

            <div className="wallet-header-left">

              <div className="wallet-main-icon">
                <RiWallet3Fill />
              </div>

              <div>

                <div className="wallet-small-title">
                  MY WALLET
                </div>

                <h1>
                  Manage Your Money
                </h1>

                <p>
                  Add cash, manage winnings and
                  withdraw securely.
                </p>

              </div>

            </div>


            <div className="wallet-security-pill">

              <FaShieldAlt />

              <span>
                Secure Wallet
              </span>

              <span className="security-green-dot"></span>

            </div>

          </div>



          {/* =====================================
              BALANCE OVERVIEW
          ===================================== */}

          <div className="balance-overview-card">

            <div className="balance-glow"></div>

            <div className="balance-overview-content">

              <div className="balance-label">
                TOTAL WALLET BALANCE
              </div>

              <div className="total-balance">

                ₹
                {(
                  user?.Wallet_balance || 0
                ).toFixed(2)}

              </div>

              <div className="balance-caption">

                <span className="live-balance-dot"></span>

                Available wallet balance

              </div>

            </div>


            <div className="balance-floating-icon">

              <MdOutlineAccountBalanceWallet />

            </div>


            <div className="balance-mini-stats">

              <div className="mini-stat">

                <span>
                  Deposit
                </span>

                <strong>
                  ₹
                  {depositChips.toFixed(2)}
                </strong>

              </div>


              <div className="mini-divider"></div>


              <div className="mini-stat">

                <span>
                  Winnings
                </span>

                <strong>
                  ₹
                  {winningChips.toFixed(2)}
                </strong>

              </div>

            </div>

          </div>



          {/* =====================================
              WALLET ACTIONS
          ===================================== */}

          <div className="wallet-section-heading">

            <div>

              <span>
                WALLET ACTIONS
              </span>

              <h2>
                Choose what you want to do
              </h2>

            </div>

            <div className="heading-line"></div>

          </div>



          <div className="wallet-action-grid">


            {/* =================================
                DEPOSIT CARD
            ================================= */}

            <div className="wallet-action-card deposit-card">

              <div className="animated-border"></div>


              <div className="wallet-card-top">

                <div className="wallet-action-icon deposit-icon">

                  <RiWallet3Fill />

                  <span className="icon-shine"></span>

                </div>


                <div className="wallet-card-status deposit-status">

                  <span></span>

                  PLAY BALANCE

                </div>

              </div>


              <div className="wallet-card-content">

                <div className="wallet-card-label">
                  Deposit Cash
                </div>

                <div className="wallet-card-amount">
                  ₹{depositChips.toFixed(2)}
                </div>

                <p>
                  Cash available for playing
                  battles and games.
                </p>

              </div>


              <div className="wallet-card-info">

                <div className="info-icon">
                  ✓
                </div>

                <span>
                  Use this balance to enter
                  battles
                </span>

              </div>


              <Link
                to={
                  settinData?.isDeposit
                    ? "/addcase"
                    : "#"
                }
                className="wallet-action-link"
              >

                <button
                  className="wallet-action-btn deposit-btn"
                  disabled={!settinData?.isDeposit}
                >

                  <span className="btn-icon">
                    <FaPlus />
                  </span>

                  <span>
                    {settinData?.isDeposit
                      ? "ADD CASH"
                      : "LOCKED"}
                  </span>

                  <span className="btn-arrow">
                    <FaArrowRight />
                  </span>

                </button>

              </Link>


              <div className="card-bottom-text">

                <span className="tiny-green-dot"></span>

                Instant wallet credit

              </div>

            </div>



            {/* =================================
                WITHDRAW CARD
            ================================= */}

            <div className="wallet-action-card withdraw-card">

              <div className="animated-border"></div>


              <div className="wallet-card-top">

                <div className="wallet-action-icon withdraw-icon">

                  <RiCoinLine />

                  <span className="icon-shine"></span>

                </div>


                <div className="wallet-card-status winning-status">

                  <span></span>

                  WINNINGS

                </div>

              </div>


              <div className="wallet-card-content">

                <div className="wallet-card-label">
                  Winning Cash
                </div>

                <div className="wallet-card-amount winning-amount">
                  ₹{winningChips.toFixed(2)}
                </div>

                <p>
                  Your earned winnings ready
                  for transfer.
                </p>

              </div>


              <div className="wallet-card-info winning-info">

                <div className="info-icon">
                  ₹
                </div>

                <span>
                  Transfer winnings directly
                  to your bank
                </span>

              </div>


              <Link
                to={
                  settinData?.isWithdrawal
                    ? "/Withdrawopt"
                    : "#"
                }
                className="wallet-action-link"
              >

                <button
                  className="wallet-action-btn withdraw-btn"
                  disabled={!settinData?.isWithdrawal}
                >

                  <span className="btn-icon">
                    <FaBank />
                  </span>

                  <span>
                    {settinData?.isWithdrawal
                      ? "WITHDRAW NOW"
                      : "LOCKED"}
                  </span>

                  <span className="btn-arrow">
                    <FaArrowRight />
                  </span>

                </button>

              </Link>


              <div className="card-bottom-text">

                <span className="tiny-gold-dot"></span>

                Secure bank transfer

              </div>

            </div>

          </div>



          {/* =====================================
              SECURITY SECTION
          ===================================== */}

          <div className="wallet-security-section">

            <div className="security-left">

              <div className="security-big-icon">
                <FaShieldAlt />
              </div>

              <div>

                <strong>
                  Your wallet is protected
                </strong>

                <p>
                  Secure transactions with
                  encrypted payment processing.
                </p>

              </div>

            </div>


            <div className="security-features">

              <div className="security-feature">

                <span>✓</span>

                SSL Secure

              </div>


              <div className="security-feature">

                <span>✓</span>

                Safe Payments

              </div>


              <div className="security-feature">

                <span>✓</span>

                Protected Wallet

              </div>

            </div>

          </div>


        </div>


        {/* =====================================
            RIGHT CONTAINER
        ===================================== */}

        <div className="mywallet-right-container">

          <Rightcontainer />

        </div>


      </div>

    </>
  );
};


export default Mywallet;